
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.834 8.649l-5.746 5.63v7.071h4.839v-9.375l1.814-1.663v12.853H7.273v-9.83l6.654-6.5h7.257v-4.84h-9.223l-6.804 6.65H.015V.18h8.468L6.518 1.994H1.83v4.84h2.42L10.636.587l.417-.407H23v8.468h-1.815z","fill-rule":"evenodd"}})])
          )
        }
      }
    